import { useState } from "react";
import type { MovieComment } from "@/types/movie";

interface CommentSectionProps {
  comments: MovieComment[];
}

export default function CommentSection({ comments }: CommentSectionProps) {
  const [expanded, setExpanded] = useState(false);
  const visibleComments = expanded ? comments : comments.slice(0, 2);

  return (
    <section id="comments" className="rounded-lg border border-background-200/80 bg-background-100/50">
      <div className="flex flex-col gap-2 border-b border-background-200/70 px-4 py-4 sm:flex-row sm:items-center sm:justify-between md:px-5">
        <div className="flex items-center gap-2">
          <h2 className="font-heading text-base font-bold text-foreground-950">用户评论</h2>
          <span className="rounded bg-background-200 px-1.5 py-0.5 font-label text-[11px] text-foreground-600">
            {comments.length}
          </span>
        </div>
        <p className="text-[11px] text-foreground-500">评论区目前仅作展示，暂未开放提交入口</p>
      </div>

      <div className="divide-y divide-background-200/60">
        {visibleComments.map((comment) => (
          <article key={comment.id} className="px-4 py-4 md:px-5">
            <div className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500/20 font-heading text-sm font-semibold text-accent-400">
                {comment.user.slice(0, 1)}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <span className="text-sm font-medium text-foreground-900">{comment.user}</span>
                  <span className="font-label text-[11px] tracking-wider text-foreground-500">
                    {comment.date}
                  </span>
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-900">
                    已阅
                  </span>
                </div>
                <p className="mt-2 text-sm leading-7 text-foreground-600">{comment.text}</p>
                <div className="mt-2.5 flex items-center gap-4 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-thumb-up-line"></i>
                    {comment.likes}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    回复
                  </span>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>

      {comments.length > 2 && (
        <div className="border-t border-background-200/70 p-3">
          <button
            type="button"
            onClick={() => setExpanded((prev) => !prev)}
            className="flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-md py-2 text-xs text-foreground-600 transition-colors hover:bg-background-100 hover:text-accent-400"
          >
            {expanded ? "收起评论" : `展开全部 ${comments.length} 条评论`}
            <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
          </button>
        </div>
      )}
    </section>
  );
}